import { Input, OnDestroy } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { ViewMode } from '../../enums';

export abstract class CrudComponent extends BaseComponent implements OnDestroy {
  @Input() public mode = ViewMode.Edit;

  public get isCreate(): boolean {
    return this.mode === ViewMode.Create;
  }

  public get isEdit(): boolean {
    return this.mode === ViewMode.Edit;
  }

  public get isView(): boolean {
    return this.mode === ViewMode.View;
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
  }
}
